import { Const } from '../lib/const.cls'

export const getters = {
	
  [Const.GET_TRADER_BASIC_INFO]: (state) => {
  	return state.TRADERBASICINFO
  },
  [Const.GET_TRADERING_INFO]: (state) => {
    return state.TRADERINGINFO
  },
  [Const.GET_HISTORY]: (state) => {
    return state.TRADERINGHISTORY
  },
  
  [Const.GET_QR_CODE]: (state) =>{
    return state.QRCODE
  },

  [Const.GET_INTERVAL]: (state) =>{
    return state.intervalid
  },
  [Const.GET_TRADING_ACCOUNT]: (state) =>{
    return state.TRADERINGACCOUNTS
  },
  [Const.GET_SCRIP_INFO]: (state) =>{
    return state.SCRIP_INFO
  },
  

  [Const.GET_MARKET_DEPTH]: (state) =>{
    return state.MARKET_DEPTH
  },

  [Const.GET_OPEN_POSITION]: (state) =>{
    return state.OPEN_POSITION
  },

  [Const.GET_OPEN_HOLDINGS]: (state, data) =>{
    return state.OPEN_HOLDINGS
  },

  [Const.GET_CLOSED_ORDER]: (state) =>{
    return state.CLOSED_ORDER
  },

  [Const.GET_MARGIN]: (state, data) => {
    return state.MARGIN_INFO
  },
  [Const.GET_DEPOSIT_HISTORY]: (state, data) => {
    return state.DEPOSIT_HISTORY
  },
  [Const.GET_WITHDRAWAL_HISTORY]: (state, data) => {
    return state.WITHDRAWAL_HISTORY
  },

  [Const.GET_BONUS_HISTORY]: (state, data) => {
    return state.BONUS_HISTORY
  },
  [Const.GET_BANKS_DETAIL]: (state, data) => {
    return state.BANKS_DETAIL
  }, 
  [Const.GET_CARDS_LIST]: (state, data) => {
    return state.CARD_LIST
  }, 
  [Const.GET_TICKET_LIST]: (state, data) => {
    return state.TICKET_LIST
  },
  [Const.GET_DOWNLOAD_PLATFORM]: (state, data) => {
    return state.DOWNLOAD
  },
  [Const.GET_COUNTERIES]: (state, data) => {
    return state.COUNTRIES
  },
  
  [Const.GET_DOCUMENT_LIST]: (state, data) => {
    return state.DOCUMENT_LIST
  },
  [Const.GET_TICKET_VIEW_LIST]: (state, data) => {
    return state.TICKET_VIEW
  },
  [Const.GET_LOADER_STATUS]: (state, data) => {
    return state.LOADER_STATUS
  },
  [Const.GET_DEPOSIT_ADDRESS]: (state, data) => {
    return state.DEPOSIT_ADDRESS
  },
  [Const.GET_GRAPH_DATA]: (state, data) => {
    return state.GRAPH_DATA
  },
  [Const.GET_CURRENT_TRADING_ACCOUNT]: (state, data) => {
    return state.CURRENT_TRADING_ACCOUNT
  },
  [Const.GET_OPEN_ORDER]: (state, data) => {
    return state.OPEN_ORDERS
  },
  [Const.GET_ORDER_HISTORY]: (state, data) => {
    return state.ORDER_HISTORY
  },
  [Const.GET_USER_LOGS]: (state, data) => {
    return state.USER_LOGS
  },
  [Const.GET_EXCHANGE_MSG]: (state, data) =>{
    return state.EXCHANGE_MSG
  },
  [Const.GET_USER_EXTRA_INFO]: (state, data) =>{
    return state.USER_EXTRA_INFO
  },

  [Const.GET_SOCKET_INDICATOR]: (state, data) =>{
    return state.SOCKET_INDICATOR
  },  
  [Const.GET_ALL_ISINS]: (state, data) =>{
    return state.ALL_ISINS
  },  
  [Const.GET_MARKET_STATUS]: (state, data) =>{
    return state.MARKET_STATUS
  }, 
  [Const.GET_WATCH_LIST]: (state, data) =>{
    return state.WATCH_LIST
  },   

  
  

}



// WEBPACK FOOTER //
// ./src/plugins/scalpert/provider/candle-history/store-addons/getters.js